// @ts-expect-error Untyped import
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import PortalIdParser from 'PortalIdParser';
import { useIFramedApplication, AppType } from '../features/iframe/useIFramedApplication';
import { getLocalStorageValue } from '../utils/browserStorage';

/**
 * Returns the host url for the iframe. `app.hubspot.com` or `app.hubspotqa.com`

 * If an override is found in localStorage, it will be used instead.
 * @returns string the host url for the iframe
 */
import { jsx as _jsx } from "react/jsx-runtime";
function getHostUrl() {
  /** Set this in localStorage to override the iframe url for local dev
   * @example window.localStorage.setItem('subscriptions-admin:iframe-host-url', 'local.hubspotqa.com') */
  const override = getLocalStorageValue('subscriptions-admin:iframe-host-url');
  if (override) {
    return override;
  }
  const host = window.location.host;
  return host.includes('local') ? host.replace('local', 'app') : host;
}
function getIFrameSrc(appSrc) {
  return `https://${getHostUrl()}/${appSrc}`;
}
const appName = 'subscriptions-admin';
export function SubscriptionsAdminHost({
  id = 'commerce-subscriptions-admin',
  initializeArgs,
  isOpen,
  'data-test-id': dataTestId,
  onClose
}) {
  const {
    handleError,
    handleOnReady,
    handleMessage,
    handleClose
  } = useIFramedApplication({
    isOpen,
    onClose,
    initializeArgs,
    appType: AppType.SUBSCRIPTIONS_ADMIN
  });
  return isOpen && /*#__PURE__*/_jsx(UIModalIFrame, {
    appName: appName,
    iframePassthruProps: {
      // props that are passed directly to the iframe
      id,
      name: appName,
      'data-test-id': dataTestId,
      'data-is-open': isOpen
    }
    // the iframe will not load at all if the sync times out, so using a massive timeout to be safe.
    ,
    initTimeout: 60000,
    show: isOpen,
    use: "fullscreen",
    width: "100%",
    height: "100%",
    src: getIFrameSrc(`subscriptions-admin/${PortalIdParser.get()}/embedded`),
    showLoadingIndicator: true,
    onInitError: handleError,
    onReady: handleOnReady,
    onReadyError: handleError,
    onMessage: handleMessage,
    onClose: handleClose
  });
}